<div class="kt-password-change__body">
	<div class="kt-login__form p-5">
		<img *ngIf="loginType === 'order-go'" class="kt-login_logo pb-5" src="/assets/media/homepage/logo_image.png" width="141" srcset="/assets/media/homepage/logo_image.png 1x, /assets/media/homepage/logo_image@2x.png 2x">
		<img *ngIf="loginType === 'suumo'" class="kt-login_logo pb-5" src="/assets/media/homepage/logo_suumo.jpg" width="225">
		<h1>登録したメールアドレスを入力してください。</h1>
		<form class="kt-form m-0" [formGroup]="form" autocomplete="off">
			<div class="row">
				<div class="form-group w-100">
					{{ 'AUTH.INPUT.EMAIL' | translate }}
					<mat-form-field appearance="fill" floatLabel="never">
						<input matInput type="email" placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}" formControlName="email" autocomplete="off" />
					</mat-form-field>
					<div *ngIf="isControlHasError('required')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
					</div>
					<div *ngIf="isControlHasError('email')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}
					</div>
					<div *ngIf="isControlHasError('minLength')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3
					</div>
					<div *ngIf="isControlHasError('maxLength')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320
					</div>
				</div>
			</div>
			<div class="kt-login__button pb-5">
				<button (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}" id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary">送信</button>
			</div>
			<div class="d-flex flex-column align-items-center">
				<p *ngIf="sent">メールを送信しました。1時間以内にメールにあるURLにアクセスして、パスワードを変更してください。</p>
				<p><a [routerLink]="loginType === 'order-go' ? '/auth/login' : '/auth/suumo-login'">ログインページへ</a></p>
			</div>
		</form>
	</div>
</div>
